
import { defineComponent } from "vue";
import { loadPaginatedEstore, getIGlowVotingPower } from "@/api/estore";
import { getUserCountryCode } from "@/api/dashboard";

export default defineComponent({
  name: "estoretabnavigator",
  data() {
    return {
      currentRank: "",
      isBCOAccount: false,
      votingPower: 0,
      votingON: false,
      ccode: -1,
    };
  },
  methods: {
    async loadPaginatedEstore() {
      const response = await loadPaginatedEstore();
      this.isBCOAccount = response.data.isBCOAccount;
    },
    async getiglowvotingpower() {
      const response = await getIGlowVotingPower();
      this.votingPower = response.data.votingPower;
    },
    async getCcode() {
      const response = await getUserCountryCode();
      this.ccode = response.data.ccode;
      localStorage.setItem("ccode", String(this.ccode));
    },
  },
  mounted() {
    this.getiglowvotingpower();
    this.loadPaginatedEstore();
    this.getCcode();
  },
});
